import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { getValidationClass } from '@/utils/formUtils';

import SelectDropdown from '@/components/common/SelectDropdown';
import FormError from '@/components/common/form/FormError';

const SelectField = ({ isRequired, name, className, ...props }) => {
  const { register, setValue, formState, formState: { errors } } = useFormContext();

  const [selected, setSelected] = useState(props.selected);

  const handleChange = (element) => {
    setSelected(element);
    setValue(name, element?.value);
  };

  return (
    <>
      <SelectDropdown
        {...props}
        {...register(name, { required: isRequired })}
        className={[
          className,
          getValidationClass(name, formState)
        ].filter(Boolean).join(' ')}
        onChange={handleChange}
        selected={{ value: selected?.value, label: selected?.label }}
      />

      {errors?.[name] && <FormError error={errors[name]} />}
    </>
  );
};

SelectField.propTypes = {
  isRequired: PropTypes.bool,
  name: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default SelectField;
